var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDraggerIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42176 3.02203C6.42176 3.46486 6.78075 3.82384 7.22358 3.82384C7.66641 3.82384 8.02539 3.46486 8.02539 3.02203C8.02539 2.5792 7.66641 2.22021 7.22358 2.22021C6.78075 2.22021 6.42176 2.5792 6.42176 3.02203Z",
    stroke: "black",
    strokeWidth: 1.5593
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2059 3.02203C13.2059 3.46486 13.5649 3.82384 14.0078 3.82384C14.4506 3.82384 14.8096 3.46486 14.8096 3.02203C14.8096 2.5792 14.4506 2.22021 14.0078 2.22021C13.5649 2.22021 13.2059 2.5792 13.2059 3.02203Z",
    stroke: "black",
    strokeWidth: 1.5593
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42079 10.626C6.42079 11.0689 6.77977 11.4278 7.2226 11.4278C7.66543 11.4278 8.02441 11.0689 8.02441 10.626C8.02441 10.1832 7.66543 9.82422 7.2226 9.82422C6.77977 9.82422 6.42079 10.1832 6.42079 10.626Z",
    stroke: "black",
    strokeWidth: 1.5593
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2059 10.626C13.2059 11.0689 13.5649 11.4278 14.0078 11.4278C14.4506 11.4278 14.8096 11.0689 14.8096 10.626C14.8096 10.1832 14.4506 9.82422 14.0078 9.82422C13.5649 9.82422 13.2059 10.1832 13.2059 10.626Z",
    stroke: "black",
    strokeWidth: 1.5593
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42079 18.2295C6.42079 18.6724 6.77977 19.0314 7.2226 19.0314C7.66543 19.0314 8.02441 18.6724 8.02441 18.2295C8.02441 17.7867 7.66543 17.4277 7.2226 17.4277C6.77977 17.4277 6.42079 17.7867 6.42079 18.2295Z",
    stroke: "black",
    strokeWidth: 1.5593
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2059 18.2295C13.2059 18.6724 13.5649 19.0314 14.0078 19.0314C14.4506 19.0314 14.8096 18.6724 14.8096 18.2295C14.8096 17.7867 14.4506 17.4277 14.0078 17.4277C13.5649 17.4277 13.2059 17.7867 13.2059 18.2295Z",
    stroke: "black",
    strokeWidth: 1.5593
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDraggerIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DraggerIcon.f6a5b4bb.svg";
export { ForwardRef as ReactComponent };